import React from 'react'
import PropTypes from 'prop-types'
import { RadioButton as AtomsRadioButton } from '@wf-common/atoms'

import Tooltip from '../tooltip/tooltip'

const propTypes = {
    label: PropTypes.string,
    tooltipContent: PropTypes.string,
    tooltipPlacement: PropTypes.string
}

const defaultProps = {
    tooltipContent: '',
    tooltipPlacement: 'top'
}

/**
 * Rendering a radio input WITHIN a radio-group.
 *
 * @param {string} [props.label] - The correspondig label (you can also set it as child, see Storybook example)
 * @param {string} [props.tooltipContent] - The optional content for a tooltip
 * @param {string} [props.tooltipPlacement] - placement for a tooltip
 * @returns {ReactElement}
 */
function RadioButton(props) {
    const { children, label, tooltipContent, tooltipPlacement } = props
    const renderLabel = label || children
    const renderLabelWithTooltip = (
        <Tooltip content={tooltipContent} placement={tooltipPlacement}>
            <span>{renderLabel}</span>
        </Tooltip>
    )

    return <AtomsRadioButton {...props}>{tooltipContent ? renderLabelWithTooltip : renderLabel}</AtomsRadioButton>
}

RadioButton.propTypes = propTypes
RadioButton.defaultProps = defaultProps

export { RadioButton }
